<mat-dialog-title style="padding: 8px 12px;">
    <div class="dialog-title-container">
      <h2 class="title">Contact Us</h2>
      <button mat-icon-button (click)="closeModal()">
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    </div>
  </mat-dialog-title>
  
  <div class="contact-us-container">
    
    <div class="contact-us-content">
      <!-- Image Section -->
      <div class="contact-image">
        <img src="assets/images/contactus.png" alt="Contact Us Image" />
      </div>
      
      <!-- Contact Info Section -->
      <div class="contact-info">
        <h2>We will get back to you ASAP!</h2>
        <div class="contact-details">
            <p><strong>Address:</strong> PO BOX 991624<br />Louisville, KY 40269</p>
            <hr class="separator" />
            <p><strong>Phone:</strong> 888-PAP-0085</p>
          </div>
          
      </div>
    </div>
  </div>
  